import React, {Component} from 'react';
import { connect } from 'react-redux';
import iconPath from "../../../helpers/iconHelper";
import { Link } from 'react-router-dom';
import {encrypt} from "../../../helpers/CryptoJs"
import FeedFooterCommentDetails from "../../FeedContainer/FeedFooterCommentDetails";
import FeedFooterLike from "../../FeedContainer/FeedFooterLike";
import AddboxRight from "../../FeedContainer/AddboxRight";
import Imagemodal from "../../FeedContainer/FeedImage/Imagemodal";
import { getlanguagelist } from "../../../helpers/changelanguage";
import App from '../../FeedContainer/FeedImage/demo/App';
import $ from "jquery";


class AlbumBody extends Component {
    constructor(props) {
      super(props);
      this.state = {
        albumId            : this.props.albumId,
        albumMedia         : this.props.albumMedia,
        albumReaction      : this.props.albumReaction,
        currentActiveImage : null,
        carousalFeed       : 0
      };
     this.scrollto   = this.scrollto.bind(this);
     this.openModal  = this.openModal.bind(this);
     this.changeView = this.changeView.bind(this);
     
    }


    changeView(){
        this.props.changeView('edit',this.state.albumId)
    }
    componentDidMount() {
     
    }
    UNSAFE_componentWillReceiveProps(nextProps,prevProps){
     
    }
    scrollto(){
        $('html, body').animate({
            'scrollTop' : $("#scrollto").position().top
        });
    }
    openModal(index){
        this.setState({
            currentActiveImage : index, 
            carousalFeed       : '499'
        })
    }
    render() {
    
    let albumMedia    = this.props.albumMedia;
    let albumReaction = this.props.albumReaction;
    console.log(albumReaction);
    let  languagelist = getlanguagelist();
    return (
        
        <div className="content_area">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-7 post_area">


            <div className="gallery_area">
                        <h3 className="pull-left album_heading">{(albumMedia.album_name != undefined) ? albumMedia.album_name : ''}</h3>
                       {/*  <h4>{(albumMedia.album_name != undefined) ? (moment(albumMedia.created_at).format('YYYY-MM-DD'))  : ''}</h4> */}
                       <div className="post_footer">
			                <div className="post-additional-info">
                                { (albumMedia.album_media != undefined) ?
                                    <FeedFooterLike 
                                        total_reaction={albumReaction.total_reaction} 
                                        my_reaction={albumReaction.my_reaction} 
                                        data_type='ALBUM' 
                                        feed_id={albumMedia.feed_id}
                                        position='post' 
                                        feed_reaction_details = {albumReaction.feed_reaction_details}
                                    />
                                    : null }

                                <div className="comments-shared">
                                    <a href={void(0)} className="post-add-icon inline-items" onClick={this.scrollto}>
                                        <img style={{width: '30px'}} src={iconPath['FEEDCOMMENT']} /> 
                                        <span style={{color: 'rgb(136, 136, 142)'}}>
                                            {albumReaction.total_comment}
                                        </span>
                                    </a>

                                    <a href="#" className="post-add-icon inline-items">
                                        <img style={{width: '30px'}} src={iconPath['FEEDSHARE']} /> 
                                        <span style={{color: 'rgb(136, 136, 142)'}}>{albumReaction.total_share}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        
                        {(albumMedia.album_id) ?
                            <div className="gallery_content_area">
                                <div className="gallery_section" id="section1">
                                <App 
                                    currentActiveImage = {this.state.currentActiveImage}
                                    media_details      = {albumMedia.album_media} 
                                    post_my_reaction   = 'LIKE'
                                    post_total_reaction= '0'
                                    post_total_comment = '0'
                                    post_total_share   = '0'
                                    position           = 'album'
                                /> 
                            
                                {
                                    (albumMedia.user_id == this.props.currentUserDetails.id) ? 
                                    <center><input type="button" className="btn_5" value={languagelist.edit} onClick={this.changeView}/></center>
                                    : null
                                }
                                
                                </div>
                            </div>
                            : null
                  
                        }
                   </div>    
                       
                    
            </div>

            {/* <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 left_area"></div>
            <div className="col-xs-12 col-sm-6 col-md-3 col-lg-3 right_area">
               {(this.props.currentUserDetails.membership != "GOLD") ?
                <AddboxRight />
                : null 
               }
            </div> */}
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-5 post_area" id="scrollto">
                <div className="row">
                    { (albumMedia.album_media != undefined) ?
                        <FeedFooterCommentDetails 
                            data_type='ALBUM' 
                            feed_id={albumMedia.feed_id}
                            toggleComment_feed_id={albumMedia.feed_id}
                            position='post'
                        />
                        : null
                    }
                </div>
            </div>
        </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    currentUserDetails : state.login.user,
  }
}
const mapDispatchToProps = dispatch => {
  return {
   
   
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AlbumBody);

